import {defaultContentOptions} from '../constants';
import {SlackContentOptions} from './types';

export enum MESSAGE_MODE {
  JSON = 'json_mode',
  WYSIWYG = 'wysiwyg_mode',
}

const _DEFAULT_SLACK_MESSAGE = {
  "blocks": [
    {
      "type": "section",
      "text": {
        "type": "mrkdwn",
        "text": "This is a Slack message. " +
          "It supports markdown :ghost: *this is bold*, and ~this is crossed out~, " +
          "and <https://pushmetrics.io|this is a link>"
      }
    }
  ]
};

export const DEFAULT_SLACK_MESSAGE = JSON.stringify(_DEFAULT_SLACK_MESSAGE, null, 4);


export const slackContentOptions: SlackContentOptions = {
  ...defaultContentOptions,
  showMergePdf: true,
  showMergeCsv: true,
};
